export default __webpack_public_path__ + "static/media/acciones_pendientes.eecb76f2.png";